import "./WhyUs.css";

const reasons = [

    {
        title: "Premium Materials",
        text: "We use high-quality materials designed for durability, appearance and long-term performance."
    },

    {
        title: "Experienced Team",
        text: "Our team brings years of experience in designing, manufacturing and installing custom signage."
    },

    {
        title: "Custom Manufacturing",
        text: "Every project is built specifically for your business, ensuring the perfect fit and finish."
    },

    {
        title: "Professional Installation",
        text: "Safe, efficient and professional installation completed by experienced crews."
    },

    {
        title: "Reliable Timelines",
        text: "Clear communication and dependable project scheduling from start to finish."
    },

    {
        title: "Customer Satisfaction",
        text: "We focus on building long-term relationships through quality workmanship and exceptional service."
    }

];

function WhyUs() {

    return (

        <div className="why-container">

            <span className="section-tag">
                WHY CHOOSE US
            </span>

            <h2>

                Trusted by Businesses Across Canada

            </h2>

            <p className="why-intro">

                Our commitment to quality, craftsmanship and customer service
                has helped businesses create signage that stands out for years.

            </p>

            <div className="why-grid">

                {reasons.map((item, index) => (

                    <div className="why-card" key={index}>

                        <div className="why-check">

                            ✓

                        </div>

                        <h3>

                            {item.title}

                        </h3>

                        <p>

                            {item.text}

                        </p>

                    </div>

                ))}

            </div>

        </div>

    );

}

export default WhyUs;